import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    padding: theme.spacing(5),
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      fontSize: '16px',
      marginTop: '0px',
      color: theme.palette.secondary.gray,
    },
    flexGrow: 1,
    minWidth: 0,
  },
  backButton: {
    width: '80px',
    paddingLeft: '0px',
    color: theme.palette.secondary.middleGray,
    '& span': {
      fontSize: '13px',
    },
  },
  title: {
    flexGrow: 1,
    fontSize: '24px',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  drowpdownWrapper: {
    position: 'relative',
  },
  searchedDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    backgroundColor: theme.palette.custom.cardBackground,
    border: `1px solid ${theme.palette.custom.imageBorder}`,
    borderTop: 'none',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
    maxHeight: '250px',
    overflowY: 'auto',
    zIndex: 1000,
  },
  searchedItem: {
    padding: '8px 16px',
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.palette.custom.imageBorder}`,
    '&:hover': {
      backgroundColor: theme.palette.custom.hoverSurface,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  searchedOptions: {
    fontSize: '14px',
    color: theme.palette.custom.menuItemText,
  },
  buttonsContainer: {
    gridColumn: 2,
    gridRow: 2,
    marginTop: '25px',
    '& button:first-child': {
      marginRight: '15px',
    },
  },
  normalButton: {
    fontWeight: 'bold',
    width: '160px',
    borderRadius: '10px',
    color: theme.palette.primary.middleGray,
    backgroundColor: theme.palette.custom.outlineButtonBackground,
    border: `0.8px solid ${theme.palette.secondary.gray}`,
    '&:hover': {
      backgroundColor: theme.palette.custom.hoverSurface,
    },
  },
  deleteButton: {
    fontWeight: 'bold',
    width: '160px',
    borderRadius: '10px',
    color: theme.palette.error.main,
    backgroundColor: theme.palette.custom.outlineButtonBackground,
    border: `0.8px solid ${theme.palette.error.main}`,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
  titleTask: {
    flexGrow: 1,
    fontSize: '1rem',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: theme.palette.primary.mainBlue,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },

}));

export default useStyles;
